import { useCallback } from 'react'
import { useModal } from '@/hooks'
import { MODALS } from '@/context'
import type { TypeCmsCartNotificationsTypes, TypeCmsCartLine } from '@/schema'

export const useCartNotifications = () => {
  const { updatePayload: updatePayloadModalStock } = useModal(MODALS.STOCK_CART)

  const handleNotifications = useCallback(
    (cart: { notifications?: TypeCmsCartNotificationsTypes[]; cartLines?: TypeCmsCartLine[] } | null | undefined) => {
      const notifications = cart?.notifications
      const cartLines = cart?.cartLines || []

      if (Array.isArray(notifications) && notifications.length > 0) {
        updatePayloadModalStock({ payload: { notifications, cartLines }, open: true })
        return true
      }
      return false
    },
    [updatePayloadModalStock]
  )

  return { handleNotifications }
}
